import { useNavigate } from 'react-router-dom';

export default function UnauthorisedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F8FAFC] px-4 text-center">
      <p className="text-8xl font-bold text-[#E2E8F0]">403</p>
      <h1 className="mt-4 text-2xl font-semibold text-[#0F172A]">Access denied</h1>
      <p className="mt-2 text-sm text-[#64748B]">
        You don&apos;t have permission to view this page.
      </p>
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="btn-secondary mt-8"
      >
        Go back
      </button>
    </div>
  );
}
